import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as ConstructionOrangeIconSvg } from './constructionOrangeIconSvg.svg';
import { ReactComponent as WirelessOrangeIconSvg } from './WirelessOrangeIconSvg.svg';
import { ReactComponent as EnergyOrangeIconSvg } from './EnergyOrangeIconSvg.svg';
import { ReactComponent as EngineeringOrangeIconSvg } from './EngineeringOrangeIconSvg.svg';
import { ReactComponent as TechnologyDeploymentOrangeIconSvg } from './TechnologyDeploymentOrangeIconSvg.svg';
import { ReactComponent as WaterServiceIconSvg } from './waterServiceIcon.svg';
import { ReactComponent as ConsultingBusinessServicesIconSvg } from './ConsultingBusinessServicesIcon.svg';
import { ReactComponent as FulfillmentServicesIconSvg } from './FulfillmentServicesIconSvg.svg';
import { ReactComponent as ArrowWhiteIconSvg } from './arrowWhite.svg';
import { ReactComponent as DataServicesIconSvg } from './DataServicesIconSvg.svg';
import { ReactComponent as SmallWhiteArrowIconSvg } from './smallWhiteArrow.svg';
import { ReactComponent as WirelineIconSvg } from './WirelineIconSvg.svg';
import { ReactComponent as WirelineSecondIconSvg } from './WirelineSecondIconSvg.svg';
import { ReactComponent as WirelineExpertiseIconSvg } from './wirelineExpertiseIconSvg.svg';
import { ReactComponent as PowerDeliveryIconSvg } from './powerDeliveryIconSvg.svg';
import { ReactComponent as OilGasIconSvg } from './oilGasIconSvg.svg';

export const ConstructionOrangeIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConstructionOrangeIconSvg ref={ref} {...props} />
));
export const WirelessOrangeIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelessOrangeIconSvg ref={ref} {...props} />);
export const EnergyOrangeIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EnergyOrangeIconSvg ref={ref} {...props} />);
export const EngineeringOrangeIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <EngineeringOrangeIconSvg ref={ref} {...props} />
));
export const TechnologyDeploymentOrangeIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <TechnologyDeploymentOrangeIconSvg ref={ref} {...props} />
));
export const WaterServiceIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WaterServiceIconSvg ref={ref} {...props} />);

export const ConsultingBusinessServicesIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <ConsultingBusinessServicesIconSvg ref={ref} {...props} />
));

export const FulfillmentServicesIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <FulfillmentServicesIconSvg ref={ref} {...props} />
));

export const ArrowWhiteIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ArrowWhiteIconSvg ref={ref} {...props} />);

export const DataServicesIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <DataServicesIconSvg ref={ref} {...props} />);

export const SmallWhiteArrowIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <SmallWhiteArrowIconSvg ref={ref} {...props} />);

export const WirelineIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelineIconSvg ref={ref} {...props} />);

export const WirelineSecondIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelineSecondIconSvg ref={ref} {...props} />);

export const WirelineExpertiseIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <WirelineExpertiseIconSvg ref={ref} {...props} />
));

export const PowerDeliveryIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PowerDeliveryIconSvg ref={ref} {...props} />);

export const OilGasIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <OilGasIconSvg ref={ref} {...props} />);
